module.exports = __webpack_public_path__ + "assets/6f0b124e.mp4";